@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.tile {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
    height: 100%;

    &:has(a) {
        cursor: pointer;
    }
}

.picture {
    display: block;
    background-color: var(--gray-100);
    aspect-ratio: 4 / 3;
}

.image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacer-16);
}

.details {
    display: flex;
    flex-direction: column;
}

.sku {
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.title {
    display: -webkit-box;
    margin-top: var(--spacer-4);
    overflow: hidden;
    font: var(--font-h-24);
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
}

.body {
    margin-top: var(--spacer-8);
    font: var(--font-p-16);
}

.price {
    margin-top: var(--spacer-12);
    font: var(--font-p-16);
}

.link {
    display: inline-flex;
    align-items: center;
    gap: var(--spacer-4);
    margin-top: var(--spacer-8);
    font: var(--font-text-link-14);
    text-decoration: underline;
}

.linkSvg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    fill: currentColor;
}

:export {
    sizes: string.unquote(
        "(min-width: #{$tablet}) 33vw, (min-width: #{$mobile}) 50vw, 100vw"
    );
}
